// This import loads the firebase namespace along with all its type information.
import SeriesSnapshot from './series-snapshot-model'

export async function load_seriesSnapshots(): Promise<SeriesSnapshot[]> {
  throw 'Not implemented'
}

export async function delete_seriesSnapshot(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_seriesSnapshot(): Promise<SeriesSnapshot> {
  throw 'Not implemented'
}
